<template lang="html">
  <div class="adv">
      <div class="banner-img">
          <!-- <img width="100%" src="https://static.qyjmed.com/webSite/aboutUs/adv/adv-bg.png" alt=""> -->
      </div>
      <!-- 优势下的图片 -->
      <div class="detail">
          <div class="container">
              <div class="detail-box">
                  <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv1.png" alt="">
                  <div class="detail-text">
                      <h2>具备雄厚的行业背景与技术实力</h2>
                      <p>我们拥有一支由优秀的职业经理人组成的管理团队，曾成功运营过国内医疗设备服务管理的上市公司。提供技术支持服务并抢先布局设备全生命周期管理服务。</p>
                  </div>
              </div>
              <div class="detail-box">
                  <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv2.png" alt="">
                  <div class="detail-text">
                      <h2>海量行业信息资源的完美整合</h2>
                      <p>平台创新利用互联网开拓信息渠道，颠覆传统的服务运营模式。拥有医疗设备服务业界完整的、端到端的云媒体资讯信息和高效服务体系，通过三大产品系统交互构建完整行业生态链，打造一站式设备服务平台。</p>
                  </div>
              </div>
          </div>
      </div>
      <!-- 其他优势 -->
      <div class="other-adv">
          <div class="container">
              <div class="adv-container">
                  <div class="other-box">
                      <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv3.png" alt="">
                      <h2>全面覆盖</h2>
                      <ul>
                            <li>国内覆盖多品牌、多设备品类、较大的医疗设备维修服务平台</li>
                            <li>提供服务商信息，3000家供应商，上万名工程师覆盖全国区域</li>
                            <li>全面的云端配件库，备机库</li>
                      </ul>
                  </div>
                  <div class="other-box">
                      <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv4.png" alt="">
                      <h2>响应速度更加快速</h2>
                      <ul>
                            <li>一键报修，微信、手机、PC随时随地无死角处理</li>
                            <li>一键报价提供最近最快响应时间供应商筛选</li>
                            <li>云端配件库，备机库，缩短等待时间</li>
                            <li>上万名工程师服务随时响应，缩短路途时间</li>
                      </ul>
                  </div>
                  <div class="other-box">
                      <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv5.png" alt="">
                      <h2>整合管理更为经济</h2>
                      <ul>
                            <li>统一计划集中采购，规模化效益降低成本</li>
                            <li>多家优质服务商比价确保最优性价比</li>
                            <li>智能匹配最近的服务商及工程师，节省差旅支出</li>
                      </ul>
                  </div>
                  <div class="other-text">
                      <p>其他<span>优势</span></p>
                  </div>
              </div>
          </div>
      </div>
      <!-- 优势 -->
      <div class="other-adv1">
          <div class="container">
              <div class="adv-container">
                  <div class="other-box">
                      <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv6.png" alt="">
                      <h2>服务质量更加可靠</h2>
                      <ul>
                            <li>提供信用评级，行业评价，筛选出最优质的服务商</li>
                            <li>信用保证金保障，第三方付款保障资金安全</li>
                            <li>售后维权服务，维修质量评估报告出具</li>
                            <li>庞大供应商团队确保托底，无后顾之忧</li>
                      </ul>
                  </div>
                  <div class="other-box">
                      <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv7.png" alt="">
                      <h2>服务流程更加专业</h2>
                      <ul>
                            <li>平台工程师提供准确信息，减少故障判断时间，避免误报乱修</li>
                            <li>规范化流程管理，提供标准化服务合同模板</li>
                            <li>严格规范售后服务流程专业化的服务质量</li>
                            <li>严格的服务要求：一年四次保养、月度回访、24小时电话支持、24小时上门、48小时解决故障。</li>
                      </ul>
                  </div>
                  <div class="other-box">
                      <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv8.png" alt="">
                      <h2>提供行业培训、职业认证等贴心增值服务</h2>
                      <ul>
                            <li>提供常见问题快速解决方案，视频教学等增值服务</li>
                            <li>与装备协会合作，由业内专业工程师提供定期培训，职业认证</li>
                      </ul>
                  </div>
                  <div class="other-text">
                      <p>Advantage</p>
                  </div>
              </div>
          </div>
      </div>
      <!-- 完善的平台 -->
      <div class="perfect">
          <div class="container">
              <div class="perfect-text">
                  <h2>完善的平台服务中心团队服务更周到</h2>
                  <p>客服部提供专业服务：24小时对外统一服务窗口，全程客服跟踪，实时信息APP反馈、VIP客户专人对接、客户投诉中心。</p>
                  <p>商务部：量身定制维修保修方案、全程跟踪合同执行、招投标服务中心，为客户解决后顾之忧。</p>
                  <p>采购部：国内国际渠道开发、供应商管理、合作工程师管理考核、集中采购、专业谈判。</p>
                  <p>工程技术部：电话故障初判、可与设备管理软件联动，远程分析故障原因，提供完整维修资料记录参考、医院电话指导、维修技术评估。</p>
              </div>
              <div class="perfect-img">
                  <img src="https://static.qyjmed.com/webSite/aboutUs/adv/adv9.png" alt="">
              </div>
          </div>
      </div>
      <div class="train">
          <div class="container">
              <h2>培训服务</h2>
              <img src="https://static.qyjmed.com/webSite/index/line.png" alt="">
              <div class="train-content">
                  <div class="train-box">
                      <p><i></i>常见问题的解决方案</p>
                      <p><i></i>职业认证</p>
                      <p><i></i>行业培训</p>
                      <p><i></i>视频教学</p>
                  </div>
              </div>
          </div>
      </div>
      <Foot></Foot>
  </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
  name: 'ouradv',
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
    .adv{
        background: #FAFAFA;
        .banner-img{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/aboutUs/adv/adv-bg.png') center;
            height: 285px;
        }
        .detail{
            margin-top: 40px;
            .container{
                .detail-box{
                    width: 532px;
                    padding:26px 28px;
                    display: inline-block;
                    background-color: white;
                    vertical-align: top;
                    img{

                    }
                    .detail-text{
                        color: #333;
                        h2{
                            text-align: center;
                            font-size: 22px;
                            font-weight: 400;
                            margin:54px 0 42px;
                        }
                        p{
                            font-size: 18px;
                            line-height: 36px;
                            padding:0 40px 30px;
                        }
                    }
                    &:first-child{
                        margin-right: 24px;
                    }
                }
            }
        }
        // 其他优势
        .other-adv,.other-adv1{
            height: 600px;
            .container{
                margin-top: 150px;
                .adv-container{
                    position: absolute;
                    .other-box{
                        width: 382px;
                        height: 600px;
                        display: inline-block;
                        margin-left: 18px;
                        background: white;
                        vertical-align: top;
                        z-index: 1;
                        img{

                        }
                        h2{
                            font-size: 22px;
                            padding:34px 0 22px 12px;
                        }
                        ul{
                            padding: 0 15px 0 30px;
                            li{
                                list-style-type: initial;
                                line-height: 36px;
                            }
                        }
                        &:first-child{
                            position: relative;
                        }

                    }
                    .other-text{
                        width: 326px;
                        height: 678px;
                        background-color: #2A6DA4;
                        position: absolute;
                        top: 0;
                        margin-top: -111px;
                        font-size: 24px;
                        color: white;
                        p{
                            padding:26px 0 0 22px;
                            span{
                                font-size: 53px;
                            }
                        }
                    }
                }
            }
        }
        // 优势
        .other-adv1{
            .container{
                .adv-container{
                    .other-box{
                        margin:0 18px 0 0;
                        position: relative;
                    }
                    .other-text{
                        right: 0;
                        p{
                            font-size: 44px;
                        }
                    }
                }
            }
        }
        // 完善
        .perfect{
            margin-top: 52px;
            margin-bottom: 60px;
            .container{
                background: white;
                .perfect-text{
                    width: 772px;
                    display: inline-block;
                    vertical-align: top;
                    font-size: 22px;
                    color: #333;
                    h2{
                        padding: 36px 0 22px 32px;
                    }
                    p{
                        font-size: 18px;
                        line-height: 28px;
                        padding:0 60px 0 32px;
                    }
                }
                .perfect-img{
                    width: 428px;
                    display: inline-block;
                    img{
                        margin-top: 30px;
                        margin-bottom: 30px;
                    }
                }
            }
        }
        // 培训服务
        .train{
            background: url('https://static.qyjmed.com/webSite/aboutUs/adv/adv-img.png');
            height: 370px;
            text-align: center;
            color: white;
            margin-bottom: -1px;
            .container{
                h2{
                    font-size: 34px;
                    padding:82px 0 34px;
                }
                .train-content{
                    .train-box{
                        margin:68px 0 0;
                        p{
                            width: 23%;
                            display: inline-block;
                            font-size: 33px;
                            color: #fff;
                            i{
                                width: 18px;
                                height: 18px;
                                background-color: white;
                                display: inline-block;
                                border-radius: 9px;
                                margin-right: 40px;
                            }
                            &:first-child{
                                width: 31%;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
